import { Message } from '@gonfalon/messages/Message';
import { Alert } from '@launchpad-ui/components';

import { ConflictKind } from '#utils/instructions/shared/constants';
import type { InstructionIndexToConflictsInfo, SemanticInstruction } from '#utils/instructions/shared/types';

import { filterInstructionsForConflict } from './instructionListUtils';

import styles from './styles.module.css';

const conflictKindToMessageId = {
  [ConflictKind.PENDING_CHANGES_WILL_FAIL]: 'pendingChanges.changeConflicts.pendingChangeWillFail',
  [ConflictKind.PROPOSED_SCHEDULED_CHANGES_WILL_FAIL]: 'pendingChanges.changeConflicts.scheduledChangeWillFail',
  [ConflictKind.PROPOSED_APPROVED_CHANGES_WILL_FAIL]: 'pendingChanges.changeConflicts.cannotApply',
} as const;

export const InstructionListConflictWrapper = ({
  instructions,
  instructionIndexToConflictsInfo,
}: {
  instructions: SemanticInstruction[];
  instructionIndexToConflictsInfo: InstructionIndexToConflictsInfo;
}) => (
  <Alert status="error" className={styles.Alert}>
    {Object.keys(conflictKindToMessageId).map((conflictKind, i) => {
      const filteredInstructions = filterInstructionsForConflict({
        instructions,
        instructionIndexToConflictsInfo,
        conflictKind: conflictKind as ConflictKind,
      });

      if (!filteredInstructions.some((ins) => ins !== undefined)) {
        return null;
      }

      const conflictReasons = new Set<string>();
      instructions.forEach((_, index) => {
        const conflictInfo = instructionIndexToConflictsInfo[index];
        if (conflictInfo?.summaryConflictKind === conflictKind) {
          conflictInfo.conflicts.forEach((conflict) => {
            if (conflict.conflictReason && conflict.conflictKind === conflictKind) {
              conflictReasons.add(conflict.conflictReason);
            }
          });
        }
      });

      const reasons = [...conflictReasons];

      return (
        <div key={i}>
          <h4 className="u-mb-s u-fw-regular">
            <Message id={conflictKindToMessageId[conflictKind as keyof typeof conflictKindToMessageId]} />
          </h4>
          {reasons.length > 0 && (
            <ul className="u-mb-s">
              {reasons.map((reason) => (
                <li key={reason}>{reason}</li>
              ))}
            </ul>
          )}
        </div>
      );
    })}
  </Alert>
);
